export default __webpack_public_path__ + "83857aa7e05c69042b5e7f065bd37815.svg";